import { render } from "./HeroiconsSolidCamera.vue?vue&type=template&id=fa2d198c"
const script = {}

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCamera.vue"]])

export default __exports__